import { Injectable } from "@angular/core";
import { ActionWithPayload } from "@obg/ngrx-utils";

import { SgaLoginTab } from "./sga-login.model";

export const ACTION_PREFIX = "[SgaLogin]";
export const SGA_LOGIN_ACTION_TYPE = {
	/**
	 * Selects Login Form Tab on SGA Login
	 */
	selectLoginTab: `${ACTION_PREFIX} Select Login tab`,
};

@Injectable({
	providedIn: "root",
})
export class SgaLoginAction {
	selectLoginTab(payload: SgaLoginTab): ActionWithPayload {
		return {
			type: SGA_LOGIN_ACTION_TYPE.selectLoginTab,
			payload,
		};
	}
}
